var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-twitter';
                    var viewUrl = 'sprite.svg#view-icon-twitter';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-twitter#icon-twitter';
                            viewUrl = 'sprite.svg?icon-twitter#view-icon-twitter';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };